import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line import/order
import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { SkeletonItem } from '../../../common/ui/loading-skeleton';

export const LoadingSkeleton = () => (
	<ChartTitle>
		<SkeletonItem width={`${gridSize * 30}px`} height={`${gridSize * 2}px`} margin="0" />
	</ChartTitle>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartTitle = styled.div({
	marginTop: token('space.200', '16px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 3}px`,
	paddingLeft: token('space.250', '20px'),
});
